export default __webpack_public_path__ + "10242cb84f36153d5d04b7de3847d2fd.png";